// src/pages/bloomterminal/components/dashboard/AddWidgetButton.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

/**
 * AddWidgetButton - Button to open the add widget popup
 *
 * Styled to match existing filter controls in the header
 */
const AddWidgetButton = ({ onClick, disabled = false }) => {
  const { t } = useTranslation();
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        flex items-center justify-center gap-2
        bg-bloom-green rounded-lg
        h-10 w-[165px] text-base font-medium text-[#f0f5f2]
        transition-all duration-200
        ${
          disabled
            ? 'opacity-50 cursor-not-allowed'
            : 'hover:bg-bloom-green-hover active:scale-95'
        }
      `}
    >
      <Plus size={24} strokeWidth={2} />
      <span>{t('analytics.addWidget')}</span>
    </button>
  );
};

export default AddWidgetButton;
